import moment from 'moment';
import momentTimezone from 'moment-timezone';

export const isDateValid = date =>
  (date instanceof moment || date instanceof momentTimezone) && date.isValid();

export const isDateBefore = (startDate, endDate) => moment(startDate).isBefore(endDate);

export const isDateInTheFuture = date => isDateBefore(moment(), date);

export const isDateDifferenceLessThan = (startDate, endDate, amount, format = 'hours') => {
  const duration = moment.duration(moment(endDate).diff(startDate));

  if (format === 'hours') {
    const hoursDifference = duration.asHours();

    return hoursDifference <= amount;
  }

  return false;
};
